/**
 * Sprawdza, czy urządzenie użytkownika korzysta z systemu iOS
 * @returns {boolean}
 */
export default function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}
